<template>
  <q-page class="q-pa-xl row items-center align-center centered-container">
    <div class="col-xs-12 col-sm-12 col-md-6 col-6 q-mb-xl">
      <div class="col-12 flex flex-start">
        <div class="text-h1 text-pastel-blue">
          4
        </div>
        <div class="text-h1 text-pastel-green">
          0
        </div>
        <div class="text-h1 text-pastel-orange">
          4
        </div>
      </div>
      <div class="col-12 text-left q-mt-md">
        <div class="text-h4">
          {{ $page.props.i18n.title }}
        </div>
        <p
          class="text-h6 q-mt-md"
          v-html="$page.props.i18n.description"
        />
      </div>
      <div class="col-12 flex flex-start q-mt-xl">
        <q-btn
          class=""
          color="primary"
          unelevated
          href="/"
          :label="$page.props.i18n.go_home"
          no-caps
        />
      </div>
    </div>
    <div class="col-xs-12 col-sm-12 col-md-6 col-6 gt-sm">
      <q-img src="/illustrations/404.svg" />
    </div>
  </q-page>
</template>
<script>
import Layout from '@/layouts/wide.vue';

export default {
  components: {
  },
  layout: Layout,
  props: {
  },
  data() {
    return {
    };
  },
  computed: {
  },
  watch: {
  },
  methods: {
  },
};
</script>
